import { lazy } from 'react';
import type { ComponentType } from './GAgGridInternal.tsx';
export type { GAgGridProps } from './GAgGridInternal.tsx';
export default lazy(() => import('./GAgGridInternal.tsx')) as ComponentType;
